export default __webpack_public_path__ + "static/media/responsive-main-banner-producer.e30bd9c5.png";